import classNames from 'classnames';
import { IconProps } from '.';

export const LayersIcon = ({ className, color = 'black' }: IconProps) => {
  return (
    <svg
      className={classNames(className)}
      width='19'
      height='18'
      viewBox='0 0 19 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.5 4.5L2.17705 5.33853L9.5 9L16.8229 5.33853L18.5 4.5L16.8229 3.66147L9.5 0L2.17705 3.66147L0.5 4.5ZM3.8541 4.5L9.5 7.32295L15.1459 4.5L9.5 1.67705L3.8541 4.5ZM3.5 7.5L2.17705 8.16147L0.5 9L2.17705 9.83853L9.5 13.5L16.8229 9.83853L18.5 9L16.8229 8.16147L15.5 7.5L13.8229 8.33853L15.1459 9L9.5 11.8229L3.8541 9L5.17705 8.33853L3.5 7.5ZM2.17705 12.6615L3.5 12L5.17705 12.8385L3.8541 13.5L9.5 16.3229L15.1459 13.5L13.8229 12.8385L15.5 12L16.8229 12.6615L18.5 13.5L16.8229 14.3385L9.5 18L2.17705 14.3385L0.5 13.5L2.17705 12.6615Z'
        fill={color}
      />
    </svg>
  );
};

export const LayersOffIcon = ({ className, color = 'currentColor' }: IconProps) => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M16.3232 12.6611L18 13.5L16.3232 14.3389L9 18L4.41309 15.707L5.53125 14.5889L9 16.3232L14.6455 13.5L13.3232 12.8389L15 12L16.3232 12.6611ZM15.9697 0.969727C16.2626 0.676833 16.7374 0.676833 17.0303 0.969727C17.3232 1.26262 17.3232 1.73738 17.0303 2.03027L2.03027 17.0303C1.73738 17.3232 1.26262 17.3232 0.969727 17.0303C0.676833 16.7374 0.676833 16.2626 0.969727 15.9697L15.9697 0.969727ZM3.58496 12.293L1.58496 14.293L0 13.5L1.67676 12.6611L3 12L3.58496 12.293ZM16.3232 8.16113L18 9L16.3232 9.83887L9 13.5L7.41309 12.707L8.53125 11.5889L9 11.8232L14.6455 9L13.3232 8.33887L15 7.5L16.3232 8.16113ZM4.67676 8.33887L3.35449 9L5.70312 10.1748L4.58496 11.293L1.67676 9.83887L0 9L1.67676 8.16113L3 7.5L4.67676 8.33887ZM13.5859 2.29199L12.4678 3.41016L9 1.67676L3.35449 4.5L8.70312 7.1748L7.58496 8.29297L1.67676 5.33887L0 4.5L1.67676 3.66113L9 0L13.5859 2.29199ZM18 4.5L16.3232 5.33887L13.2412 6.87891L16.4141 3.70605L18 4.5Z'
        fill={color}
      />
    </svg>
  );
};
